import React, { useState, useEffect } from 'react';
import AuthService                    from 'services/auth.service';
import ReferralService                from 'services/referral.service';
import ReferralTable                  from './ReferralTable';
import ReferralDetailsModal           from './ReferralDetailsModal';
import { Tabs, Tab }                  from 'react-bootstrap';
import moment                         from 'moment';

export function Referral() {
  const formatDate = (date) => {
    return moment(date).format('DD-MM-YYYY');
  }
  const defaultMeta = {total_count: 0, total_pages: 0, current_page: 1};
  const [showLogDetailsModal, setShowLogDetailsModal] = useState(false);
  const [log, setLog] = useState({})
  const [specialties, setSpecialties] = useState([])

  const [byLogs, setByLogs] = useState([]);
  const [byPage, setByPage] = useState(1);
  const [byMeta, setByMeta] = useState(defaultMeta);
  const [byLoading, setByLoading] = useState(false);
  const [byStartDate, setByStartDate] = useState(null);
  const [byEndDate, setByEndDate] = useState(formatDate(new Date()));

  const [toLogs, setToLogs] = useState([]);
  const [toPage, setToPage] = useState(1);
  const [toMeta, setToMeta] = useState(defaultMeta);
  const [toLoading, setToLoading] = useState(false);
  const [toStartDate, setToStartDate] = useState(null);
  const [toEndDate, setToEndDate] = useState(formatDate(new Date()));

  useEffect(() => {
    getReferralLogs(1);
  }, [byStartDate, byEndDate]); // eslint-disable-line

  useEffect(() => {
    getRefereeLogs(1);
  }, [toStartDate, toEndDate]); // eslint-disable-line

  const getReferralLogs = (page) => {
    setByPage(page);
    setByLoading(true);
    const params = {
      start_date: byStartDate,
      end_date: byEndDate,
      page: page
    }
    ReferralService.referrals(params).then(
      (data) => {
        setByLogs(data.referrals)
        setByMeta(data.meta)
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    ).then(() => {
      setByLoading(false);
    });
  }

  const getRefereeLogs = (page) => {
    setToPage(page);
    setToLoading(true);
    const params = {
      start_date: toStartDate,
      end_date: toEndDate,
      page: page
    }
    ReferralService.referrers(params).then(
      (data) => {
        setToLogs(data.referrals)
        setToMeta(data.meta)
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    ).then(() => {
      setToLoading(false);
    });
  }

  useEffect(() => {
    if(Object.keys(log).length !== 0){
      setShowLogDetailsModal(true);
    }
  }, [log]); // eslint-disable-line

  useEffect(() => {
    ReferralService.specialties().then(
      (data) => {
        setSpecialties(data.map((s) => { return {value: s.id, label: s.name};}))
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  }, []); // eslint-disable-line

  return (
    <div id="main-content-target" className="referral-page">
      <h1 className="header-title">Referral Logs</h1>

      <Tabs defaultActiveKey="refer_by" className="referral-tabs">
        <Tab eventKey="refer_by" title="Referred By">
          <ReferralTable 
            listType={'By'} 
            logs={byLogs} 
            setShowLogDetailsModal={setShowLogDetailsModal} 
            setLog={setLog} 
            loading={toLoading} 
            getLogs={getReferralLogs} 
            meta={byMeta} 
            page={byPage}
            setStartDate={setByStartDate}
            startDate={byStartDate}
            setEndDate={setByEndDate}
            endDate={byEndDate}
            />
        </Tab>
        <Tab eventKey="refer_to" title="Refer To">
          <ReferralTable 
            listType={'To'} 
            logs={toLogs} 
            setShowLogDetailsModal={setShowLogDetailsModal} 
            setLog={setLog} 
            specialties={specialties} 
            loading={byLoading} 
            getLogs={getRefereeLogs} 
            meta={toMeta} 
            page={toPage}
            setStartDate={setToStartDate}
            startDate={toStartDate}
            setEndDate={setToEndDate}
            endDate={toEndDate}
            />
        </Tab>
      </Tabs>
      <ReferralDetailsModal log={log} showLogDetailsModal={showLogDetailsModal} setShowLogDetailsModal={setShowLogDetailsModal}/>
    </div>
  );
}

export default Referral;